import { ComponentType } from 'react'
import { SvgIconComponent } from '@material-ui/icons'

export interface IRouteItem {
  path: string
  name: string
  component: ComponentType<any>
}

export interface IDrawerRouteItem {
  name: string
  title: string
  path: string
  icon: SvgIconComponent
  disabled?: boolean
  allowedRoles?: UserRole[]
  children?: IDrawerRouteItem[]
}

export enum TransactionDirection {
  IN = 'in',
  OUT = 'out',
}

export enum BusinessBalanceType {
  DEFAULT = 'default',
  BONUS = 'bonus',
}

export enum PaymentType {
  CASH = 1,
  CASHLESS = 2,
}

export enum BusinessTransactionType {
  REPLENISHMENT = 1,
  TRANSACTION_FEE = 2,
  WELCOME_BONUS = 3,
  REGISTRATION_FEE = 4,
  WITHDRAW_EXPIRED_BALANCE = 5,
  OTHER = 6,
}

export enum BusinessTransactionStatus {
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILURE = 'failure',
  INCOMPLETE = 'incomplete',
}

export enum FranchiseeTransactionType {
  REPLENISHMENT = 1,
  COMMISSION = 2,
}

export enum FranchiseeReplenishmentType {
  CASH = 1,
  CASHLESS = 2,
  ONLINE = 3,
}

export enum FranchiseeTransactionStatus {
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILURE = 'failure',
  INCOMPLETE = 'incomplete',
}

export enum TransactionFeeType {
  PERCENT = 'percent',
  FIX = 'fix',
}

export interface ISelectItem<ValueT> {
  value: ValueT
  label: string
}

export enum UserRole {
  SUPERADMIN = 'superadmin',
  ADMIN = 'admin',
  SALES_SUPERVISOR = 'sales:supervisor',
  SALES_MANAGER = 'sales:manager',
  FRANCHISEE = 'franchisee',
}

export enum PromocodeDiscountType {
  PERCENT = 'percent',
  FIX = 'fix',
}

export enum ApplicationType {
  BUSINESS = 'business',
  CLIENT = 'client',
}

export interface IPagination {
  offset: number
  limit: number
  page: number
}
